// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'wowjs/css/libs/animate.css'
import { WOW } from 'wowjs'
import '@/assets/iconfont/iconfont.css'
import VueI18n from 'vue-i18n' // 注意：Vue 2 应该用 vue-i18n@8.x，而不是 vue-i18n@9.x（后者是 Vue 3 的）

// 导入语言包
import zh from './locales/zh'
import en from './locales/en'

// 必须先 use VueI18n 插件
Vue.use(VueI18n)

// 获取浏览器语言（只取主要部分，如 'zh' 而不是 'zh-CN'）
const browserLanguage = navigator.language.split('-')[0]

// 支持的语言列表
const supportedLanguages = ['en', 'zh'] // 添加你支持的所有语言代码

// 设置默认语言：如果浏览器语言在支持列表中则使用，否则回退到'zh'
const defaultLocale = supportedLanguages.includes(browserLanguage)
  ? browserLanguage
  : 'en'

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: defaultLocale, // 自动选择的默认语言
  fallbackLocale: 'en', // 回退语言
  messages: { zh, en } // 语言包
})

// 挂载 WOW.js 到 Vue 原型（Vue 2 方式）
Vue.prototype.$wow = WOW

Vue.config.productionTip = false

// 创建 Vue 实例
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
